import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Placeholder, PlaceholderLine, PlaceholderMedia } from '@/src/elements/placeholder'

export const IntentionPlaceholder = ({ testID }: { testID: string }): ReactNode => (
  <View
    testID={testID}
    className="native:mx-6 mx-6 mb-10 flex h-full w-full max-w-[400px] flex-1 flex-col items-center justify-center gap-6 self-center"
  >
    <Placeholder noBackground className="w-full">
      <View className="w-full flex-col items-center gap-2">
        <PlaceholderMedia size="avatar-md" className="flex-col" />
        <PlaceholderLine className="max-w-[283px] text-center" size="md" />
        <PlaceholderLine className="max-w-[100px] text-center" size="md" />
      </View>
    </Placeholder>
    <Placeholder className="w-full flex-col">
      <PlaceholderLine className="w-full" size="md" />
      <PlaceholderLine className="mt-2 w-full" size="md" />
    </Placeholder>
    <Placeholder noBackground className="w-full items-center justify-center">
      <View className="w-full max-w-[200px] gap-2">
        <PlaceholderLine contrast="dark" className="w-[200px] text-center" size="md" />
      </View>
    </Placeholder>
  </View>
)
